import { Expose, Type } from 'class-transformer';

export class ContactResponseDto {
    @Expose()
    id: string;

    @Expose()
    fullName: string;

    @Expose()
    positionTitle: string;

    @Expose()
    email: string;

    @Expose()
    phone: string;

    @Expose()
    @Type(() => Date)
    createdAt: Date;

    @Expose()
    @Type(() => Date)
    updatedAt: Date;
}
